<template>
	<div class="expandable-html">
		<div
			ref="content"
			@click="handleClick"
			class="event-card__description"
			v-html="postDescription(content)"
			:class="{ collapsed: !isExpanded && isTooLong }"
		/>

		<div v-if="!isExpanded && isTooLong" class="fade-overlay"></div>

		<div v-if="isTooLong" class="event-card__description__show-more">
			<button @click="toggle">
				{{ isExpanded ? collapseText : expandText }}
			</button>
		</div>
	</div>
</template>

<script>
import linkifyThreadText from '@/mixins/linkifyThreadText'
export default {
	name: 'ExpandableHtml',
	mixins: [linkifyThreadText],
	props: {
		content: {
			type: String,
			default: '',
		},
		maxLines: {
			type: Number,
			default: 5,
		},
		expandText: {
			type: String,
			default: 'Show More',
		},
		collapseText: {
			type: String,
			default: 'Show Less',
		},
	},

	data() {
		return {
			isExpanded: false,
			isTooLong: false,
		}
	},

	mounted() {
		this.$nextTick(this.checkHeight)
	},

	watch: {
		content() {
			this.$nextTick(this.checkHeight)
		},
	},

	methods: {
		handleClick() {
			this.$emit('handleClick')
		},
		toggle() {
			this.isExpanded = !this.isExpanded
		},

		checkHeight() {
			const el = this.$refs.content
			if (!el) return

			const lineHeight = parseFloat(getComputedStyle(el).lineHeight)
			const lines = Math.floor(el.scrollHeight / lineHeight)

			this.isTooLong = lines > this.maxLines
		},
	},
}
</script>
